import { NodeViewWrapper } from "@tiptap/react";
import offer1 from '../../../../../assets/images/offers/offer1.png';
import offer2 from '../../../../../assets/images/offers/offer2.png';
import offer3 from '../../../../../assets/images/offers/offer3.png';
import offer4 from '../../../../../assets/images/offers/offer4.png';
import offer5 from '../../../../../assets/images/offers/offer5.png';

const offersData = [
    {
        title: "Custom Home Construction",
        imagePath: offer1
    },
    {
        title: "End-to-End Execution",
        imagePath: offer2
    },
    {
        title: "Transparent Pricing",
        imagePath: offer3
    },
    {
        title: "Quality Construction",
        imagePath: offer4
    },
    {
        title: "Timely Delivery",
        imagePath: offer5
    }
];

export const OffersBlockView = (props) => {
    const { editor, getPos } = props;

    const handleCaptionClick = () => {
        const nodePosition = getPos();
        editor.commands.setNodeSelection(nodePosition);
    };

    return (
        <NodeViewWrapper data-type='offers'>
            <div className="offers-node-wrapper">
                <div onClick={handleCaptionClick}>
                    <div className='offers-content'>
                        <h5>What We Offers</h5>
                        <div className="offers-grid">
                            {offersData.map((item, index) => (
                                <div key={index} className="offers-item">
                                    <div className="offers-image">
                                        <img src={item.imagePath} alt={item.title} />
                                    </div>
                                    <p className="offers-title">{item.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </NodeViewWrapper>
    );
};